import React, { useEffect } from "react";
import ExclamationIcon from "../../assets/img/exclamation-mark-icon.svg";
import "../DiyIcvDigilockerSingleEducation/style.css";
import FeatherIcon from "feather-icons-react";

const DigilockerPopup = React.forwardRef((props, ref) => {
  const {
    showModalBox,
    record,
    title,
    description,
    isAdd,
    checkStatus,
    handleSaveData,
  } = props;

  const closePopupHandler = (e) => {
    e.preventDefault();
    props.closePopup();
  };

  const proceedHandler = (e) => {
    e.preventDefault();
    // props.proceedHandler();
    props.handleSaveData(e);
  };

  useEffect(() => {
    const body = document.querySelector("body");
    if (showModalBox) {
      body.classList.add("modal-open");
    } else {
      body.classList.remove("modal-open");
    }
  }, [showModalBox]);

  return (
    <>
      {/* <div
        className={
          "dashboard custom-modal-dialog " +
          (showModalBox === 1 ? "show" : "hidden")
        }
        onClick={(e) => closePopupHandler(e)}
      >
        <div
          className="modal-wrapper"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            className="modal-content p-4 no-scroll"
            style={{ maxWidth: "370px" }}
          >
            <div className="text-left">
              <img src={ExclamationIcon} alt="" />
              <h5 className="mt-3">{title}</h5>
              <p className="text-muted">{description}</p>
            </div>

            <div className="row">
              <div className="col-md-12 d-flex justify-content-between">
                <button
                  className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                  onClick={(e) => closePopupHandler(e)}
                >
                  Cancel
                </button>
                <button
                  className={
                    isAdd
                      ? "btn btn-success btn-lg btn-block mt-3"
                      : "btn btn-danger btn-lg btn-block mt-3"
                  }
                  onClick={
                    checkStatus != 1 
                    ? (e) => proceedHandler(e)
                    : (e) => closePopupHandler(e)
                  }
                    
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {showModalBox && (
        <div className="dashboard custom-modal-dialog show">
          <div className="modal-wrapper">
            <div className="modal-content p-4 m-2">
              <div>
              <span className="fnt-15 fnt-smi-bld align-item-right cross float-right" ><FeatherIcon icon="x" style={{cursor: "pointer" }} onClick={(e) => {closePopupHandler(e)}}/> </span>

                <h4>Education check via Digilocker</h4>
                <p>
                  You will be redirected to DigiLocker page to fetch education
                  documents please follow simple 5 steps
                </p>
                <ol className="p-3">
                  <li>Sign in using your Aadhar number.</li>
                  <li>Verify your identity with OTP.</li>
                  <li>Login using your digilocker 6-digit PIN.</li>
                  <li>Provide Consent for Document attachment.</li>
                  <li>Redirect back to iBridge Application.</li>
                </ol>
                <h6 className="fnt-16 text-primary">
                  Not found your education document on Digilocker?
                </h6>
                <p className="fnt-12 text-gray text-justify">
                  * If your university or board is not currently listed on
                  DigiLocker or Your Degree/marksheets not fetched via
                  DigiLocker, don't worry! This wont impact your verification.
                </p>
              </div>

              <div className="row">
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-lg btn-block"
                    onClick={(e) => {
                      proceedHandler(e);
                    }}
                  >
                    Continue
                  </button>
                  {/* <button
                  className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2" onClick={(e) => {closePopupHandler(e)}}>
                  Back
                </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default DigilockerPopup;
